import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import { CylinderGeometry } from './CylinderGeometry.js';

var ConeGeometry = /*#__PURE__*/function (_CylinderGeometry) {
  _inheritsLoose(ConeGeometry, _CylinderGeometry);

  function ConeGeometry(radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength) {
    var _this;

    if (radius === void 0) {
      radius = 1;
    }

    if (height === void 0) {
      height = 1;
    }

    if (radialSegments === void 0) {
      radialSegments = 8;
    }

    if (heightSegments === void 0) {
      heightSegments = 1;
    }

    if (openEnded === void 0) {
      openEnded = false;
    }

    if (thetaStart === void 0) {
      thetaStart = 0;
    }

    if (thetaLength === void 0) {
      thetaLength = Math.PI * 2;
    }

    _this = _CylinderGeometry.call(this, 0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength) || this;
    _this.type = 'ConeGeometry';
    _this.parameters = {
      radius: radius,
      height: height,
      radialSegments: radialSegments,
      heightSegments: heightSegments,
      openEnded: openEnded,
      thetaStart: thetaStart,
      thetaLength: thetaLength
    };
    return _this;
  }

  ConeGeometry.fromJSON = function fromJSON(data) {
    return new ConeGeometry(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
  };

  return ConeGeometry;
}(CylinderGeometry);

export { ConeGeometry, ConeGeometry as ConeBufferGeometry };